import React from 'react';
import Markdown from './_js/Markdown';

export default function Page(props) {
    const [text, setText] = React.useState('');

    fetch(props.content).then(resp => resp.text())
        .then(text => setText(text));

    React.useEffect(() => {
        document.title = `Notes - ${props.title}`;
    });

    return (
        <div className="flex-1">
            <div className="sticky top-0 flex items-center justify-center w-full h-12 pt-3 font-serif text-xl tracking-widest text-gray-500 uppercase bg-white border-b-2 border-gray-300 z-1">
                {props.title}
            </div>
            <div className="max-h-full">
                <div className="mx-auto mt-16 mb-20 max-w-3/4 lg:max-w-1/2">
                    <Markdown source={text} />
                </div >
            </div >
        </div >

    );
}

